import { Component } from '@angular/core';
import { EcitationReportService } from 'src/services/ecitation-report.service';
import * as XLSX from 'xlsx';
import { FileSaverService } from 'ngx-filesaver';
@Component({
    selector: 'app-ecitation-delivery-annual-report',
    templateUrl: './ecitation-delivery-annual-report.component.html',
    styleUrls: ['./ecitation-delivery-annual-report.component.css'],
    standalone: false
})
export class EcitationDeliveryAnnualReportComponent {

  showReportResults = false;
  year:number= new Date ().getFullYear();
  listOfYearsOptions:number[] =[];
  listAnnualReport:any=[]

  constructor(private ecitationReportService:EcitationReportService, private fileSaverService: FileSaverService){
    for(let i=0; i<=4; i++){
    const cYear:number= new Date ().getFullYear(); 
  this.listOfYearsOptions.push(cYear - i)
    }
  }
  pageSize:number = 25;
	currentPage:number =1;

	getItems(){
		const satrtIndex = (this.currentPage - 1) * this.pageSize;
		return this.listAnnualReport.slice(satrtIndex , satrtIndex + this.pageSize);
	}

	onPageChange(pageNumber:number){
		this.currentPage = pageNumber
	}

	getTotalPages():number{
		return Math.ceil(this.listAnnualReport.length / this.pageSize);
	}

	getVisiblePages():number[]{
		const totalVisiblePages = 10;
		const visiblePages:number[]=[];
		const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages/2));
		const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
		for(let i = startPage; i<=endPage; i++){
			visiblePages.push(i)
		}
		return visiblePages
	}

  getCurrentPageTotal(){
    if(this.currentPage * 10 > this.listAnnualReport.length ){
     return this.listAnnualReport.length 
    } else{
      return this.currentPage * 10 
    }
  }
  

  selectYear(val:any){
    this.year = val  
  }

  getAnnualReport(){
    this.ecitationReportService.getdeliveryAnnualReport(this.year).subscribe((res)=>{
      this.listAnnualReport = res
    })
  }

  excelExport() {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    const headers = ['MONTH/YEAR','DNR', 'DAIT-PROTECT','COWS','CCAP','MUNICIPAL COURT','LOCAL COURT','NO ACTION','DELIVERED TOTAL']

    const worksheet = XLSX.utils.json_to_sheet([],{header:headers})
    XLSX.utils.sheet_add_json(worksheet , this.listAnnualReport , {origin:'A2',skipHeader:true})

    const workbook = {
      Sheets: {
        'Delivery-Annual-Report': worksheet
      },
      SheetNames: ['Delivery-Annual-Report']
    }

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE })
    this.fileSaverService.save(blobData, `Delivery-Annual-Report-${this.year}`)
  }

}
